import React, { useContext } from "react";
import FlatButton from "~/shared/FlatBtn";
import { Header, Content, Footer } from "../styles";
import { Container, Row, Col } from "react-bootstrap";
import { subcategories } from "../options";
import { MultiSelectFormContext } from "~/contexts/MultiSelectForm";

const SubCategoryForm = () => {
    const { handleChange, values } = useContext(MultiSelectFormContext);

    const chooseSubCategory = (categoryId: number) => {
        handleChange("subcategory", categoryId);
    };

    return (
        <>
            <Container>
                <Header>
                    <h1>Qual Tipo de Ensaio?</h1>
                </Header>

                <Content>
                    <Row>
                        {subcategories.map((subcategory) => (
                            <Col key={subcategory.id} sm={6} lg={3}>
                                <FlatButton
                                    className={values?.subcategory === subcategory.id && "selected"}
                                    onClick={() => chooseSubCategory(subcategory.id)}
                                    block
                                >
                                    {subcategory.name}
                                </FlatButton>
                            </Col>
                        ))}
                    </Row>
                </Content>
            </Container>
        </>
    );
};

export default SubCategoryForm;
